import 'styled-components/macro';
import React from 'react';
import { Typography, useTheme } from '@harver/shared-ui';

import { ContentCard } from '../../../components/ContentCard';
import { useContent } from '../../../branding/content.context';
import CookieBanner from '../../../components/CookieBanner';

export function AlreadyUnavailableInterview() {
    const theme = useTheme();
    const { interviewCancellation: LANG } = useContent();

    const template = LANG.alreadyUnavailableInterview;
    document.title = template.title;
    return (
        <>
            <ContentCard>
                <div
                    css={{
                        textAlign: 'center',
                        margin: `${theme.sizes.xxxLarge} 0`,
                    }}
                >
                    <Typography
                        testId="interview.alreadyUnavailable"
                        css={{
                            textAlign: 'center',
                            marginBottom: theme.sizes.large,
                        }}
                        variant="h2"
                    >
                        {template.title}
                    </Typography>
                    <Typography
                        css={{
                            textAlign: 'center',
                        }}
                        variant="body2"
                    >
                        {template.message}
                    </Typography>
                </div>
            </ContentCard>
            <CookieBanner />
        </>
    );
}
